import { defineComponent } from 'vue';
import SuccessMessageCode from '@/presentation/components/success-message/success-message.code';

export default defineComponent({
	setup: () => {
		const code = new SuccessMessageCode();

		return {
			successMessage: code.successMessage
		};
	}
});
